import { MoreVert } from '@mui/icons-material';
import RoundedImage from './RoundedImage';
import {Dropdown, Menu, MenuButton, MenuItem} from '@mui/joy';
import {useContext, useEffect, useState} from "react";
import {WebRTCContext} from "../../contexts/WebRTCContext";
import ImageLoadingManager from "./ImageLoadingManager";

const RecordingCard = ({ recording, onPlay, onDelete, openMenu, setOpenMenu }) => {

    const { rtcSession } = useContext(WebRTCContext);
    const [imageSrc, setImageSrc] = useState(null);
    const { id, start_ms, end_ms, duration_ms, size_bytes } = recording;

    // Format times
    const formatDate = (ms) => {
        const date = new Date(ms);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    };

    const formatTime = (ms) => {
        const date = new Date(ms);
        return date.toLocaleTimeString('en-US', { hour12: true });
    };

    // Calculate duration and size
    const duration = (duration_ms / 1000).toFixed(2); // seconds
    const size = (size_bytes / 1048576).toFixed(2);  // MB

    const handleMenuClick = (event) => {
        // Toggle the menu
        if (openMenu === id) {
            setOpenMenu(null); // Close the menu if it's already open
        } else {
            setOpenMenu(id); // Open the menu for this item
        }
    };

    function onDownload(recording) {
        console.log('Download recording TODO');
    }

    useEffect(() => {
        if (rtcSession) {
            const imageLoadingManager = rtcSession.imageLoadingManager
            console.log('RecordingCard useEffect: ', imageLoadingManager, id);
            const recordingId = id;
            if (imageLoadingManager && recordingId) {
                // Define a listener with the expected onSuccess and onFailure methods.
                const listener = {
                    onSuccess: (imageData) => {
                        setImageSrc(imageData);
                        console.log(`RecordingCard (${recordingId}) - image load succeed:`, imageData);
                    },
                    onFailure: (error) => {
                        console.error(`RecordingCard (${recordingId}) - image load failed:`, error);
                    }
                };

                // Request the image from the manager.
                imageLoadingManager.requestImage(recordingId, imageLoadingManager.ImageTypes.RECORDING_PREVIEW, listener);

                // Cancel the request if the component unmounts or imageId changes.
                return () => {
                    imageLoadingManager.cancelRequest(recordingId, listener);
                };
            }
        }
    }, [rtcSession, id]);

    return (
        <div style={styles.row}>
            <div style={styles.verticalLine}>
                <div style={styles.dot}></div>
            </div>
            <div style={styles.card}>
                <div style={styles.imageContainer} onClick={() => onPlay(recording)}>
                    <RoundedImage
                        src={imageSrc || 'https://images.unsplash.com/photo-1527549993586-dff825b37782?auto=format&h=160'}
                        alt="A description of the image"
                        width="140px"
                        height="80px"
                        style={styles.image}
                    />
                </div>
                <div style={styles.cardContent}>
                    <p style={styles.text}><strong>Recording {id}</strong> {formatDate(start_ms)} </p>
                    <p style={styles.text}>
                        {formatTime(start_ms)} - {formatTime(end_ms)} ({duration}s)
                    </p>
                    <p style={styles.text}>{size}MB</p>
                </div>
                {/* Menu for 3-dots icon */}
                <Dropdown>
                    <MenuButton
                        variant={'plain'}
                        onClick={handleMenuClick} // Toggle menu on click
                        style={{ cursor: 'pointer' }}
                    >
                        <MoreVert />
                    </MenuButton>
                    {openMenu === id && (
                        <Menu>
                            <MenuItem onClick={() => { onDelete(recording); setOpenMenu(null); }}>Delete</MenuItem>
                            <MenuItem onClick={() => { onDownload(recording); setOpenMenu(null); }}>Download</MenuItem>
                        </Menu>
                    )}
                </Dropdown>
            </div>
        </div>
    );
};

// Inline styles
const styles = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        position: 'relative',
    },
    verticalLine: {
        position: 'absolute',
        left: '-8px',
        top: '0',
        bottom: '0',
        width: '1.5px',
        backgroundColor: '#d3d1d1',
    },
    dot: {
        position: 'absolute',
        left: '-5px',
        top: '40%',
        width: '4.5px',
        height: '4px',
        borderRadius: '50%',
        backgroundColor: '#333',
        border: '4px solid white',
    },
    card: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: '10px',
        borderRadius: '8px',
        position: 'relative',
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: '600px',
    },
    imageContainer: {
        position: 'relative',
        cursor: 'pointer',
        width: '140px',
        height: '80px',
        borderRadius: '8px',
    },
    image: {
        width: '100%',
        height: '100%',
        borderRadius: '8px',
    },
    cardContent: {
        flexGrow: 1,
        marginLeft: '15px',
        paddingRight: '20px',
    },
    text: {
        fontSize: '14px',
        margin: '5px 0',
    },
};

export default RecordingCard;
